export default class Config {
    public static readonly COGNITO_IDENTITY_POOL_ID_DEV = 'us-west-2:e8cb962f-8ab7-42e2-8f6e-ea18155ac448';
    public static readonly PINPOINT_APP_ID_DEV = '4ef4ed3156d040ee939861e4528475a9';
}